import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/categories")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/knowledges/categories", search: location.search, replace: true });
  },
  component: () => null,
});
